import { useContext } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import RadixModalHeader from './RadixModalHeader';
import { MessageSquare } from 'lucide-react';
import MessageTabs from './MessageTabs';

export default function MessageSelected({
  isOpen=true,
  onClose,
  recordsData = [],
  sheetName
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40" style={{ background: 'rgba(15, 23, 42, 0.55)' }} />
        <Dialog.Content
          id="messaging-modal"
          className="fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-0 overflow-hidden w-full max-w-5xl flex flex-col max-h-[95vh]"
          style={{ background: 'var(--theme-surface)', borderRadius: 'var(--theme-radius-lg)', boxShadow: 'var(--theme-shadow-dialog)', transform: 'translate(-50%, -50%)', backfaceVisibility: 'hidden' }}
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
        >
          <RadixModalHeader dialog={Dialog}
            icon={MessageSquare}
            title="Messages"
            subtitle="Compose and send SMS messages to your customers"
            actions={recordsData.length > 0 && (
              <span className="pill-t pill-t-accent">{recordsData.length} Customers Selected</span>
            )}
          />

          <div className="flex-grow overflow-hidden px-6 py-4">
            <MessageTabs recordsData={recordsData} onClose={onClose} sheetName={sheetName} />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}